import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["facetName", "facetQuery"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function createBrowserLocalStorageCache(options) {
  var namespaceKey = "algoliasearch-client-js-".concat(options.key); // eslint-disable-next-line functional/no-let

  var storage;

  var getStorage = function getStorage() {
    if (storage === undefined) {
      storage = options.localStorage || window.localStorage;
    }

    return storage;
  };

  var getNamespace = function getNamespace() {
    return JSON.parse(getStorage().getItem(namespaceKey) || '{}');
  };

  return {
    get: function get(key, defaultValue) {
      var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        miss: function miss() {
          return Promise.resolve();
        }
      };
      return Promise.resolve().then(function () {
        var keyAsString = JSON.stringify(key);
        var value = getNamespace()[keyAsString];
        return Promise.all([value || defaultValue(), value !== undefined]);
      }).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            value = _ref2[0],
            exists = _ref2[1];

        return Promise.all([value, exists || events.miss(value)]);
      }).then(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
            value = _ref4[0];

        return value;
      });
    },
    set: function set(key, value) {
      return Promise.resolve().then(function () {
        var namespace = getNamespace(); // eslint-disable-next-line functional/immutable-data

        namespace[JSON.stringify(key)] = value;
        getStorage().setItem(namespaceKey, JSON.stringify(namespace));
        return value;
      });
    },
    delete: function _delete(key) {
      return Promise.resolve().then(function () {
        var namespace = getNamespace(); // eslint-disable-next-line functional/immutable-data

        delete namespace[JSON.stringify(key)];
        getStorage().setItem(namespaceKey, JSON.stringify(namespace));
      });
    },
    clear: function clear() {
      return Promise.resolve().then(function () {
        getStorage().removeItem(namespaceKey);
      });
    }
  };
} // @todo Add logger on options to debug when caches go wrong.


function createFallbackableCache(options) {
  var caches = _toConsumableArray(options.caches);

  var current = caches.shift(); // eslint-disable-line functional/immutable-data

  if (current === undefined) {
    return createNullCache();
  }

  return {
    get: function get(key, defaultValue) {
      var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        miss: function miss() {
          return Promise.resolve();
        }
      };
      return current.get(key, defaultValue, events).catch(function () {
        return createFallbackableCache({
          caches: caches
        }).get(key, defaultValue, events);
      });
    },
    set: function set(key, value) {
      return current.set(key, value).catch(function () {
        return createFallbackableCache({
          caches: caches
        }).set(key, value);
      });
    },
    delete: function _delete(key) {
      return current.delete(key).catch(function () {
        return createFallbackableCache({
          caches: caches
        }).delete(key);
      });
    },
    clear: function clear() {
      return current.clear().catch(function () {
        return createFallbackableCache({
          caches: caches
        }).clear();
      });
    }
  };
}

function createNullCache() {
  return {
    get: function get(_key, defaultValue) {
      var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        miss: function miss() {
          return Promise.resolve();
        }
      };
      var value = defaultValue();
      return value.then(function (result) {
        return Promise.all([result, events.miss(result)]);
      }).then(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
            result = _ref6[0];

        return result;
      });
    },
    set: function set(_key, value) {
      return Promise.resolve(value);
    },
    delete: function _delete(_key) {
      return Promise.resolve();
    },
    clear: function clear() {
      return Promise.resolve();
    }
  };
}

function createInMemoryCache() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    serializable: true
  };
  // eslint-disable-next-line functional/no-let
  var cache = {};
  return {
    get: function get(key, defaultValue) {
      var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        miss: function miss() {
          return Promise.resolve();
        }
      };
      var keyAsString = JSON.stringify(key);

      if (keyAsString in cache) {
        return Promise.resolve(options.serializable ? JSON.parse(cache[keyAsString]) : cache[keyAsString]);
      }

      var promise = defaultValue();

      var miss = events && events.miss || function () {
        return Promise.resolve();
      };

      return promise.then(function (value) {
        return miss(value);
      }).then(function () {
        return promise;
      });
    },
    set: function set(key, value) {
      // eslint-disable-next-line functional/immutable-data
      cache[JSON.stringify(key)] = options.serializable ? JSON.stringify(value) : value;
      return Promise.resolve(value);
    },
    delete: function _delete(key) {
      // eslint-disable-next-line functional/immutable-data
      delete cache[JSON.stringify(key)];
      return Promise.resolve();
    },
    clear: function clear() {
      cache = {};
      return Promise.resolve();
    }
  };
}

function createAuth(authMode, appId, apiKey) {
  var credentials = {
    'x-algolia-api-key': apiKey,
    'x-algolia-application-id': appId
  };
  return {
    headers: function headers() {
      return authMode === AuthMode.WithinHeaders ? credentials : {};
    },
    queryParameters: function queryParameters() {
      return authMode === AuthMode.WithinQueryParameters ? credentials : {};
    }
  };
} // eslint-disable-next-line functional/prefer-readonly-type


function shuffle(array) {
  var c = array.length - 1; // eslint-disable-line functional/no-let
  // eslint-disable-next-line functional/no-loop-statement

  for (c; c > 0; c--) {
    var b = Math.floor(Math.random() * (c + 1));
    var a = array[c];
    array[c] = array[b]; // eslint-disable-line functional/immutable-data, no-param-reassign

    array[b] = a; // eslint-disable-line functional/immutable-data, no-param-reassign
  }

  return array;
}

function addMethods(base, methods) {
  if (!methods) {
    return base;
  }

  Object.keys(methods).forEach(function (key) {
    // eslint-disable-next-line functional/immutable-data, no-param-reassign
    base[key] = methods[key](base);
  });
  return base;
}

function encode(format) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  // eslint-disable-next-line functional/no-let
  var i = 0;
  return format.replace(/%s/g, function () {
    return encodeURIComponent(args[i++]);
  });
}

var version = '4.15.0';
var AuthMode = {
  /**
   * If auth credentials should be in query parameters.
   */
  WithinQueryParameters: 0,

  /**
   * If auth credentials should be in headers.
   */
  WithinHeaders: 1
};

function createMappedRequestOptions(requestOptions, timeout) {
  var options = requestOptions || {};
  var data = options.data || {};
  Object.keys(options).forEach(function (key) {
    if (['timeout', 'headers', 'queryParameters', 'data', 'cacheable'].indexOf(key) === -1) {
      data[key] = options[key]; // eslint-disable-line functional/immutable-data
    }
  });
  return {
    data: Object.entries(data).length > 0 ? data : undefined,
    timeout: options.timeout || timeout,
    headers: options.headers || {},
    queryParameters: options.queryParameters || {},
    cacheable: options.cacheable
  };
}

var CallEnum = {
  /**
   * If the host is read only.
   */
  Read: 1,

  /**
   * If the host is write only.
   */
  Write: 2,

  /**
   * If the host is both read and write.
   */
  Any: 3
};
var HostStatusEnum = {
  Up: 1,
  Down: 2,
  Timeouted: 3
}; // By default, API Clients at Algolia have expiration delay
// of 5 mins. In the JavaScript client, we have 2 mins.

var EXPIRATION_DELAY = 2 * 60 * 1000;

function createStatefulHost(host) {
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : HostStatusEnum.Up;
  return _objectSpread(_objectSpread({}, host), {}, {
    status: status,
    lastUpdate: Date.now()
  });
}

function isStatefulHostUp(host) {
  return host.status === HostStatusEnum.Up || Date.now() - host.lastUpdate > EXPIRATION_DELAY;
}

function isStatefulHostTimeouted(host) {
  return host.status === HostStatusEnum.Timeouted && Date.now() - host.lastUpdate <= EXPIRATION_DELAY;
}

function createStatelessHost(options) {
  if (typeof options === 'string') {
    return {
      protocol: 'https',
      url: options,
      accept: CallEnum.Any
    };
  }

  return {
    protocol: options.protocol || 'https',
    url: options.url,
    accept: options.accept || CallEnum.Any
  };
}

var MethodEnum = {
  Delete: 'DELETE',
  Get: 'GET',
  Post: 'POST',
  Put: 'PUT'
};

function createRetryableOptions(hostsCache, statelessHosts) {
  return Promise.all(statelessHosts.map(function (statelessHost) {
    return hostsCache.get(statelessHost, function () {
      return Promise.resolve(createStatefulHost(statelessHost));
    });
  })).then(function (statefulHosts) {
    var hostsUp = statefulHosts.filter(function (host) {
      return isStatefulHostUp(host);
    });
    var hostsTimeouted = statefulHosts.filter(function (host) {
      return isStatefulHostTimeouted(host);
    });
    /**
     * Note, we put the hosts that previously timeouted on the end of the list.
     */

    var hostsAvailable = [].concat(_toConsumableArray(hostsUp), _toConsumableArray(hostsTimeouted));
    var statelessHostsAvailable = hostsAvailable.length > 0 ? hostsAvailable.map(function (host) {
      return createStatelessHost(host);
    }) : statelessHosts;
    return {
      getTimeout: function getTimeout(timeoutsCount, baseTimeout) {
        /**
         * Imagine that you have 4 hosts, if timeouts will increase
         * on the following way: 1 (timeouted) > 4 (timeouted) > 5 (200)
         *
         * Note that, the very next request, we start from the previous timeout
         *
         *  5 (timeouted) > 6 (timeouted) > 7 ...
         *
         * This strategy may need to be reviewed, but is the strategy on the our
         * current v3 version.
         */
        var timeoutMultiplier = hostsTimeouted.length === 0 && timeoutsCount === 0 ? 1 : hostsTimeouted.length + 3 + timeoutsCount;
        return timeoutMultiplier * baseTimeout;
      },
      statelessHosts: statelessHostsAvailable
    };
  });
}

var isNetworkError = function isNetworkError(_ref7) {
  var isTimedOut = _ref7.isTimedOut,
      status = _ref7.status;
  return !isTimedOut && ~~status === 0;
};

var isRetryable = function isRetryable(response) {
  var status = response.status;
  var isTimedOut = response.isTimedOut;
  return isTimedOut || isNetworkError(response) || ~~(status / 100) !== 2 && ~~(status / 100) !== 4;
};

var isSuccess = function isSuccess(_ref8) {
  var status = _ref8.status;
  return ~~(status / 100) === 2;
};

var retryDecision = function retryDecision(response, outcomes) {
  if (isRetryable(response)) {
    return outcomes.onRetry(response);
  }

  if (isSuccess(response)) {
    return outcomes.onSuccess(response);
  }

  return outcomes.onFail(response);
};

function retryableRequest(transporter, statelessHosts, request, requestOptions) {
  var stackTrace = []; // eslint-disable-line functional/prefer-readonly-type

  /**
   * First we prepare the payload that do not depend from hosts.
   */

  var data = serializeData(request, requestOptions);
  var headers = serializeHeaders(transporter, requestOptions);
  var method = request.method; // On `GET`, the data is proxied to query parameters.

  var dataQueryParameters = request.method !== MethodEnum.Get ? {} : _objectSpread(_objectSpread({}, request.data), requestOptions.data);

  var queryParameters = _objectSpread(_objectSpread(_objectSpread({
    'x-algolia-agent': transporter.userAgent.value
  }, transporter.queryParameters), dataQueryParameters), requestOptions.queryParameters);

  var timeoutsCount = 0; // eslint-disable-line functional/no-let

  var retry = function retry(hosts, // eslint-disable-line functional/prefer-readonly-type
  getTimeout) {
    /**
     * We iterate on each host, until there is no host left.
     */
    var host = hosts.pop(); // eslint-disable-line functional/immutable-data

    if (host === undefined) {
      throw createRetryError(stackTraceWithoutCredentials(stackTrace));
    }

    var payload = {
      data: data,
      headers: headers,
      method: method,
      url: serializeUrl(host, request.path, queryParameters),
      connectTimeout: getTimeout(timeoutsCount, transporter.timeouts.connect),
      responseTimeout: getTimeout(timeoutsCount, requestOptions.timeout)
    };
    /**
     * The stackFrame is pushed to the stackTrace so we
     * can have information about onRetry and onFailure
     * decisions.
     */

    var pushToStackTrace = function pushToStackTrace(response) {
      var stackFrame = {
        request: payload,
        response: response,
        host: host,
        triesLeft: hosts.length
      }; // eslint-disable-next-line functional/immutable-data

      stackTrace.push(stackFrame);
      return stackFrame;
    };

    var decisions = {
      onSuccess: function onSuccess(response) {
        return deserializeSuccess(response);
      },
      onRetry: function onRetry(response) {
        var stackFrame = pushToStackTrace(response);
        /**
         * If response is a timeout, we increaset the number of
         * timeouts so we can increase the timeout later.
         */

        if (response.isTimedOut) {
          timeoutsCount++;
        }

        return Promise.all([
        /**
         * Failures are individually send the logger, allowing
         * the end user to debug / store stack frames even
         * when a retry error does not happen.
         */
        transporter.logger.info('Retryable failure', stackFrameWithoutCredentials(stackFrame)),
        /**
         * We also store the state of the host in failure cases. If the host, is
         * down it will remain down for the next 2 minutes. In a timeout situation,
         * this host will be added end of the list of hosts on the next request.
         */
        transporter.hostsCache.set(host, createStatefulHost(host, response.isTimedOut ? HostStatusEnum.Timeouted : HostStatusEnum.Down))]).then(function () {
          return retry(hosts, getTimeout);
        });
      },
      onFail: function onFail(response) {
        pushToStackTrace(response);
        throw deserializeFailure(response, stackTraceWithoutCredentials(stackTrace));
      }
    };
    return transporter.requester.send(payload).then(function (response) {
      return retryDecision(response, decisions);
    });
  };
  /**
   * Finally, for each retryable host perform request until we got a non
   * retryable response. Some notes here:
   *
   * 1. The reverse here is applied so we can apply a `pop` later on => more performant.
   * 2. We also get from the retryable options a timeout multiplier that is tailored
   * for the current context.
   */


  return createRetryableOptions(transporter.hostsCache, statelessHosts).then(function (options) {
    return retry(_toConsumableArray(options.statelessHosts).reverse(), options.getTimeout);
  });
}

function createTransporter(options) {
  var hostsCache = options.hostsCache,
      logger = options.logger,
      requester = options.requester,
      requestsCache = options.requestsCache,
      responsesCache = options.responsesCache,
      timeouts = options.timeouts,
      userAgent = options.userAgent,
      hosts = options.hosts,
      queryParameters = options.queryParameters,
      headers = options.headers;
  var transporter = {
    hostsCache: hostsCache,
    logger: logger,
    requester: requester,
    requestsCache: requestsCache,
    responsesCache: responsesCache,
    timeouts: timeouts,
    userAgent: userAgent,
    headers: headers,
    queryParameters: queryParameters,
    hosts: hosts.map(function (host) {
      return createStatelessHost(host);
    }),
    read: function read(request, requestOptions) {
      /**
       * First, we compute the user request options. Now, keep in mind,
       * that using request options the user is able to modified the intire
       * payload of the request. Such as headers, query parameters, and others.
       */
      var mappedRequestOptions = createMappedRequestOptions(requestOptions, transporter.timeouts.read);

      var createRetryableRequest = function createRetryableRequest() {
        /**
         * Then, we prepare a function factory that contains the construction of
         * the retryable request. At this point, we may *not* perform the actual
         * request. But we want to have the function factory ready.
         */
        return retryableRequest(transporter, transporter.hosts.filter(function (host) {
          return (host.accept & CallEnum.Read) !== 0;
        }), request, mappedRequestOptions);
      };
      /**
       * Once we have the function factory ready, we need to determine of the
       * request is "cacheable" - should be cached. Note that, once again,
       * the user can force this option.
       */


      var cacheable = mappedRequestOptions.cacheable !== undefined ? mappedRequestOptions.cacheable : request.cacheable;
      /**
       * If is not "cacheable", we immediatly trigger the retryable request, no
       * need to check cache implementations.
       */

      if (cacheable !== true) {
        return createRetryableRequest();
      }
      /**
       * If the request is "cacheable", we need to first compute the key to ask
       * the cache implementations if this request is on progress or if the
       * response already exists on the cache.
       */


      var key = {
        request: request,
        mappedRequestOptions: mappedRequestOptions,
        transporter: {
          queryParameters: transporter.queryParameters,
          headers: transporter.headers
        }
      };
      /**
       * With the computed key, we first ask the responses cache
       * implemention if this request was been resolved before.
       */

      return transporter.responsesCache.get(key, function () {
        /**
         * If the request has never resolved before, we actually ask if there
         * is a current request with the same key on progress.
         */
        return transporter.requestsCache.get(key, function () {
          return transporter.requestsCache
          /**
           * Finally, if there is no request in progress with the same key,
           * this `createRetryableRequest()` will actually trigger the
           * retryable request.
           */
          .set(key, createRetryableRequest()).then(function (response) {
            return Promise.all([transporter.requestsCache.delete(key), response]);
          }, function (err) {
            return Promise.all([transporter.requestsCache.delete(key), Promise.reject(err)]);
          }).then(function (_ref9) {
            var _ref10 = _slicedToArray(_ref9, 2),
                _ = _ref10[0],
                response = _ref10[1];

            return response;
          });
        });
      }, {
        /**
         * Of course, once we get this response back from the server, we
         * tell response cache to actually store the received response
         * to be used later.
         */
        miss: function miss(response) {
          return transporter.responsesCache.set(key, response);
        }
      });
    },
    write: function write(request, requestOptions) {
      /**
       * On write requests, no cache mechanisms are applied, and we
       * proxy the request immediately to the requester.
       */
      return retryableRequest(transporter, transporter.hosts.filter(function (host) {
        return (host.accept & CallEnum.Write) !== 0;
      }), request, createMappedRequestOptions(requestOptions, transporter.timeouts.write));
    }
  };
  return transporter;
}

function createUserAgent(version) {
  var userAgent = {
    value: "Algolia for JavaScript (".concat(version, ")"),
    add: function add(options) {
      var addedUserAgent = "; ".concat(options.segment).concat(options.version !== undefined ? " (".concat(options.version, ")") : '');

      if (userAgent.value.indexOf(addedUserAgent) === -1) {
        // eslint-disable-next-line functional/immutable-data
        userAgent.value = "".concat(userAgent.value).concat(addedUserAgent);
      }

      return userAgent;
    }
  };
  return userAgent;
}

function deserializeSuccess(response) {
  // eslint-disable-next-line functional/no-try-statement
  try {
    return JSON.parse(response.content);
  } catch (e) {
    throw createDeserializationError(e.message, response);
  }
}

function deserializeFailure(_ref11, stackFrame) {
  var content = _ref11.content,
      status = _ref11.status;
  // eslint-disable-next-line functional/no-let
  var message = content; // eslint-disable-next-line functional/no-try-statement

  try {
    message = JSON.parse(content).message;
  } catch (e) {// ..
  }

  return createApiError(message, status, stackFrame);
}

function serializeUrl(host, path, queryParameters) {
  var queryParametersAsString = serializeQueryParameters(queryParameters); // eslint-disable-next-line functional/no-let

  var url = "".concat(host.protocol, "://").concat(host.url, "/").concat(path.charAt(0) === '/' ? path.substr(1) : path);

  if (queryParametersAsString.length) {
    url += "?".concat(queryParametersAsString);
  }

  return url;
}

function serializeQueryParameters(parameters) {
  var isObjectOrArray = function isObjectOrArray(value) {
    return Object.prototype.toString.call(value) === '[object Object]' || Object.prototype.toString.call(value) === '[object Array]';
  };

  return Object.keys(parameters).map(function (key) {
    return encode('%s=%s', key, isObjectOrArray(parameters[key]) ? JSON.stringify(parameters[key]) : parameters[key]);
  }).join('&');
}

function serializeData(request, requestOptions) {
  if (request.method === MethodEnum.Get || request.data === undefined && requestOptions.data === undefined) {
    return undefined;
  }

  var data = Array.isArray(request.data) ? request.data : _objectSpread(_objectSpread({}, request.data), requestOptions.data);
  return JSON.stringify(data);
}

function serializeHeaders(transporter, requestOptions) {
  var headers = _objectSpread(_objectSpread({}, transporter.headers), requestOptions.headers);

  var serializedHeaders = {};
  Object.keys(headers).forEach(function (header) {
    var value = headers[header]; // @ts-ignore
    // eslint-disable-next-line functional/immutable-data

    serializedHeaders[header.toLowerCase()] = value;
  });
  return serializedHeaders;
}

function stackTraceWithoutCredentials(stackTrace) {
  return stackTrace.map(function (stackFrame) {
    return stackFrameWithoutCredentials(stackFrame);
  });
}

function stackFrameWithoutCredentials(stackFrame) {
  var modifiedHeaders = stackFrame.request.headers['x-algolia-api-key'] ? {
    'x-algolia-api-key': '*****'
  } : {};
  return _objectSpread(_objectSpread({}, stackFrame), {}, {
    request: _objectSpread(_objectSpread({}, stackFrame.request), {}, {
      headers: _objectSpread(_objectSpread({}, stackFrame.request.headers), modifiedHeaders)
    })
  });
}

function createApiError(message, status, transporterStackTrace) {
  return {
    name: 'ApiError',
    message: message,
    status: status,
    transporterStackTrace: transporterStackTrace
  };
}

function createDeserializationError(message, response) {
  return {
    name: 'DeserializationError',
    message: message,
    response: response
  };
}

function createRetryError(transporterStackTrace) {
  return {
    name: 'RetryError',
    message: 'Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.',
    transporterStackTrace: transporterStackTrace
  };
}

var createSearchClient = function createSearchClient(options) {
  var appId = options.appId;
  var auth = createAuth(options.authMode !== undefined ? options.authMode : AuthMode.WithinHeaders, appId, options.apiKey);
  var transporter = createTransporter(_objectSpread(_objectSpread({
    hosts: [{
      url: "".concat(appId, "-dsn.algolia.net"),
      accept: CallEnum.Read
    }, {
      url: "".concat(appId, ".algolia.net"),
      accept: CallEnum.Write
    }].concat(shuffle([{
      url: "".concat(appId, "-1.algolianet.com")
    }, {
      url: "".concat(appId, "-2.algolianet.com")
    }, {
      url: "".concat(appId, "-3.algolianet.com")
    }]))
  }, options), {}, {
    headers: _objectSpread(_objectSpread(_objectSpread({}, auth.headers()), {
      'content-type': 'application/x-www-form-urlencoded'
    }), options.headers),
    queryParameters: _objectSpread(_objectSpread({}, auth.queryParameters()), options.queryParameters)
  }));
  var base = {
    transporter: transporter,
    appId: appId,
    addAlgoliaAgent: function addAlgoliaAgent(segment, version) {
      transporter.userAgent.add({
        segment: segment,
        version: version
      });
    },
    clearCache: function clearCache() {
      return Promise.all([transporter.requestsCache.clear(), transporter.responsesCache.clear()]).then(function () {
        return undefined;
      });
    }
  };
  return addMethods(base, options.methods);
};

var customRequest = function customRequest(base) {
  return function (request, requestOptions) {
    if (request.method === MethodEnum.Get) {
      return base.transporter.read(request, requestOptions);
    }

    return base.transporter.write(request, requestOptions);
  };
};

var _initIndex = function initIndex(base) {
  return function (indexName) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var searchIndex = {
      transporter: base.transporter,
      appId: base.appId,
      indexName: indexName
    };
    return addMethods(searchIndex, options.methods);
  };
};

var multipleQueries = function multipleQueries(base) {
  return function (queries, requestOptions) {
    var requests = queries.map(function (query) {
      return _objectSpread(_objectSpread({}, query), {}, {
        params: serializeQueryParameters(query.params || {})
      });
    });
    return base.transporter.read({
      method: MethodEnum.Post,
      path: '1/indexes/*/queries',
      data: {
        requests: requests
      },
      cacheable: true
    }, requestOptions);
  };
};

var multipleSearchForFacetValues = function multipleSearchForFacetValues(base) {
  return function (queries, requestOptions) {
    return Promise.all(queries.map(function (query) {
      var _query$params = query.params,
          facetName = _query$params.facetName,
          facetQuery = _query$params.facetQuery,
          params = _objectWithoutProperties(_query$params, _excluded);

      return _initIndex(base)(query.indexName, {
        methods: {
          searchForFacetValues: searchForFacetValues
        }
      }).searchForFacetValues(facetName, facetQuery, _objectSpread(_objectSpread({}, requestOptions), params));
    }));
  };
};

var findAnswers = function findAnswers(base) {
  return function (query, queryLanguages, requestOptions) {
    return base.transporter.read({
      method: MethodEnum.Post,
      path: encode('1/answers/%s/prediction', base.indexName),
      data: {
        query: query,
        queryLanguages: queryLanguages
      },
      cacheable: true
    }, requestOptions);
  };
};

var search = function search(base) {
  return function (query, requestOptions) {
    return base.transporter.read({
      method: MethodEnum.Post,
      path: encode('1/indexes/%s/query', base.indexName),
      data: {
        query: query
      },
      cacheable: true
    }, requestOptions);
  };
};

var searchForFacetValues = function searchForFacetValues(base) {
  return function (facetName, facetQuery, requestOptions) {
    return base.transporter.read({
      method: MethodEnum.Post,
      path: encode('1/indexes/%s/facets/%s/query', base.indexName, facetName),
      data: {
        facetQuery: facetQuery
      },
      cacheable: true
    }, requestOptions);
  };
};

var LogLevelEnum = {
  Debug: 1,
  Info: 2,
  Error: 3
};
/* eslint no-console: 0 */

function createConsoleLogger(logLevel) {
  return {
    debug: function debug(message, args) {
      if (LogLevelEnum.Debug >= logLevel) {
        console.debug(message, args);
      }

      return Promise.resolve();
    },
    info: function info(message, args) {
      if (LogLevelEnum.Info >= logLevel) {
        console.info(message, args);
      }

      return Promise.resolve();
    },
    error: function error(message, args) {
      console.error(message, args);
      return Promise.resolve();
    }
  };
}

function createBrowserXhrRequester() {
  return {
    send: function send(request) {
      return new Promise(function (resolve) {
        var baseRequester = new XMLHttpRequest();
        baseRequester.open(request.method, request.url, true);
        Object.keys(request.headers).forEach(function (key) {
          return baseRequester.setRequestHeader(key, request.headers[key]);
        });

        var createTimeout = function createTimeout(timeout, content) {
          return setTimeout(function () {
            baseRequester.abort();
            resolve({
              status: 0,
              content: content,
              isTimedOut: true
            });
          }, timeout * 1000);
        };

        var connectTimeout = createTimeout(request.connectTimeout, 'Connection timeout'); // eslint-disable-next-line functional/no-let

        var responseTimeout; // eslint-disable-next-line functional/immutable-data

        baseRequester.onreadystatechange = function () {
          if (baseRequester.readyState > baseRequester.OPENED && responseTimeout === undefined) {
            clearTimeout(connectTimeout);
            responseTimeout = createTimeout(request.responseTimeout, 'Socket timeout');
          }
        }; // eslint-disable-next-line functional/immutable-data


        baseRequester.onerror = function () {
          // istanbul ignore next
          if (baseRequester.status === 0) {
            clearTimeout(connectTimeout);
            clearTimeout(responseTimeout);
            resolve({
              content: baseRequester.responseText || 'Network request failed',
              status: baseRequester.status,
              isTimedOut: false
            });
          }
        }; //  eslint-disable-next-line functional/immutable-data


        baseRequester.onload = function () {
          clearTimeout(connectTimeout);
          clearTimeout(responseTimeout);
          resolve({
            content: baseRequester.responseText,
            status: baseRequester.status,
            isTimedOut: false
          });
        };

        baseRequester.send(request.data);
      });
    }
  };
}

function algoliasearch(appId, apiKey, options) {
  var commonOptions = {
    appId: appId,
    apiKey: apiKey,
    timeouts: {
      connect: 1,
      read: 2,
      write: 30
    },
    requester: createBrowserXhrRequester(),
    logger: createConsoleLogger(LogLevelEnum.Error),
    responsesCache: createInMemoryCache(),
    requestsCache: createInMemoryCache({
      serializable: false
    }),
    hostsCache: createFallbackableCache({
      caches: [createBrowserLocalStorageCache({
        key: "".concat(version, "-").concat(appId)
      }), createInMemoryCache()]
    }),
    userAgent: createUserAgent(version).add({
      segment: 'Browser',
      version: 'lite'
    }),
    authMode: AuthMode.WithinQueryParameters
  };
  return createSearchClient(_objectSpread(_objectSpread(_objectSpread({}, commonOptions), options), {}, {
    methods: {
      search: multipleQueries,
      searchForFacetValues: multipleSearchForFacetValues,
      multipleQueries: multipleQueries,
      multipleSearchForFacetValues: multipleSearchForFacetValues,
      customRequest: customRequest,
      initIndex: function initIndex(base) {
        return function (indexName) {
          return _initIndex(base)(indexName, {
            methods: {
              search: search,
              searchForFacetValues: searchForFacetValues,
              findAnswers: findAnswers
            }
          });
        };
      }
    }
  }));
} // eslint-disable-next-line functional/immutable-data


algoliasearch.version = version;
export default algoliasearch;